// import React from 'react';
// import { Row, Col } from 'reactstrap';
// import Heading from 'components/Heading';
// import AllTabsAndTables from './components/AllTabsAndTables';
// import DashboardCardChart from './components/DashboardCardChart';
// import GoogleMapCard from './components/GoogleMapCard';
// import OrderStatusChart from './components/DashboardCardChart/components/AllCharts/components/OrderStatusChart';

// const Dashboard = () => {
//   return (
//     <>
//       <div className="mb-3 pb-1 top-head">
//         <div className="d-flex align-items-center">
//           <Heading title="Dashboard" />
//         </div>
//       </div>
//       <DashboardCardChart />

//       <AllTabsAndTables />
//       <Row className="mt-4">
//         <Col md={6} className="mb-4">
//           <GoogleMapCard />
//         </Col>
//         <Col md={6} className="mb-4">
//           <OrderStatusChart />
//         </Col>
//       </Row>
//     </>
//   );
// };

// export default Dashboard;

// import React, { useContext } from 'react';
// import { Row, Col } from 'reactstrap';
// import { authContext } from 'contexts/AuthContext';
// import Heading from 'components/Heading';
// import Loader from 'components/common/Loader';
// import AllTabsAndTables from './components/AllTabsAndTables';
// import DashboardCardChart from './components/DashboardCardChart';
// import GoogleMapCard from './components/GoogleMapCard';
// import OrderStatusChart from './components/DashboardCardChart/components/AllCharts/components/OrderStatusChart';

// const Dashboard = () => {
//   const { auth } = useContext(authContext);

//   // Wait for auth to be fully loaded before rendering dashboard
//   if (!auth || !auth.data || auth.loading) {
//     return (
//       <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
//         <Loader />
//       </div>
//     );
//   }

//   return (
//     <>
//       <div className="mb-3 pb-1 top-head">
//         <div className="d-flex align-items-center">
//           <Heading title="Dashboard" />
//         </div>
//       </div>
//       <DashboardCardChart />

//       <AllTabsAndTables />
//       <Row className="mt-4">
//         <Col md={6} className="mb-4">
//           <GoogleMapCard />
//         </Col>
//         <Col md={6} className="mb-4">
//           <OrderStatusChart />
//         </Col>
//       </Row>
//     </>
//   );
// };

// export default Dashboard;

// import React, { useContext } from 'react';
// import { Row, Col } from 'reactstrap';
// import { authContext } from 'contexts/AuthContext';
// import Heading from 'components/Heading';
// import Loader from 'components/common/Loader';
// import AllTabsAndTables from './components/AllTabsAndTables';
// import DashboardCardChart from './components/DashboardCardChart';
// // import GoogleMapCard from './components/GoogleMapCard';
// import OrderStatusChart from './components/DashboardCardChart/components/AllCharts/components/OrderStatusChart';

// const Dashboard = () => {
//   const { auth } = useContext(authContext);
//   if (!auth || !auth.data || auth.loading) {
//     return (
//       <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
//         <Loader />
//       </div>
//     );
//   }

//   return (
//     <>
//       <div className="mb-3 pb-1 top-head">
//         <div className="d-flex align-items-center">
//           <Heading title="Dashboard" />
//         </div>
//       </div>
//       <DashboardCardChart />

//       <AllTabsAndTables />
//       <Row className="mt-4">
//         {/* <Col md={6} className="mb-4">
//           <GoogleMapCard />
//         </Col> */}
//         <Col md={12} className="mb-4">
//           <OrderStatusChart />
//         </Col>
//       </Row>
//     </>
//   );
// };

// export default Dashboard;

import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
} from 'react';
import { Row, Col } from 'reactstrap';
import { useLazyQuery } from '@apollo/client';
import { authContext } from 'contexts/AuthContext';
import Heading from 'components/Heading';
import Loader from 'components/common/Loader';
import CardWithTitle from 'components/CardWithTitle';
import { collectPermissionNames, hasAnyPermission } from 'utils/permissions';
import {
  GET_ROLES_WITH_PERMISSIONS,
  GET_USER_INFO,
} from 'pages/Login/LoginGraphQL';

import FirebaseGradeTouchData from './FirebaseGradeTouchData';
import AllTabsAndTables from './components/AllTabsAndTables';
import DashboardCardChart from './components/DashboardCardChart';
import ActiveUserMetrics from './components/ActiveUserMetrics';
import OrderStatusChart from './components/DashboardCardChart/components/AllCharts/components/OrderStatusChart';
import PermissionNotice from './components/PermissionNotice';
import NotificationTaskSection from './components/NotificationTaskSection';
import { DASHBOARD_PERMISSION_KEYS } from './permissions';

const Dashboard = () => {
  const { auth, setAuthData } = useContext(authContext);
  const [fetchUserInfo] = useLazyQuery(GET_USER_INFO, {
    fetchPolicy: 'network-only',
  });
  const [fetchRolesWithPermissions] = useLazyQuery(GET_ROLES_WITH_PERMISSIONS, {
    fetchPolicy: 'network-only',
  });
  const refreshInFlightRef = useRef(false);
  const lastRefreshAtRef = useRef(0);
  const lastSignatureRef = useRef('');
  const permissionNames = useMemo(
    () => collectPermissionNames(auth?.data),
    [auth?.data],
  );

  const permissions = useMemo(
    () => ({
      listing: hasAnyPermission(
        permissionNames,
        DASHBOARD_PERMISSION_KEYS.listing,
      ),
      bids: hasAnyPermission(permissionNames, DASHBOARD_PERMISSION_KEYS.bids),
      vendors: hasAnyPermission(
        permissionNames,
        DASHBOARD_PERMISSION_KEYS.vendors,
      ),
      orders: hasAnyPermission(
        permissionNames,
        DASHBOARD_PERMISSION_KEYS.orders,
      ),
      history: hasAnyPermission(
        permissionNames,
        DASHBOARD_PERMISSION_KEYS.history,
      ),
      orderStatus: hasAnyPermission(
        permissionNames,
        DASHBOARD_PERMISSION_KEYS.orderStatus,
      ),
      notifications: hasAnyPermission(
        permissionNames,
        DASHBOARD_PERMISSION_KEYS.notifications,
      ),
      tasks: hasAnyPermission(
        permissionNames,
        DASHBOARD_PERMISSION_KEYS.tasks,
      ),
    }),
    [permissionNames],
  );

  const getCurrentUserId = useCallback(
    () => auth?.data?.userId ?? auth?.data?.id ?? auth?.data?.user?.id ?? null,
    [auth?.data],
  );

  const buildSignature = (rolesList, permissionsList) => {
    const roleNames = (rolesList || [])
      .map((role) => role?.name)
      .filter(Boolean)
      .sort()
      .join('|');
    const permissionNamesList = (permissionsList || [])
      .map(
        (permission) =>
          permission?.permissionName || permission?.name || permission,
      )
      .filter(Boolean)
      .map((name) => `${name}`.trim())
      .sort()
      .join('|');
    return `${roleNames}::${permissionNamesList}`;
  };

  const refreshAuthPermissions = useCallback(async () => {
    const token = auth?.data?.token;
    const userId = getCurrentUserId();
    if (!token || !userId) return;

    const now = Date.now();
    if (refreshInFlightRef.current) return;
    if (now - lastRefreshAtRef.current < 5000) return;

    refreshInFlightRef.current = true;
    lastRefreshAtRef.current = now;

    try {
      let rolesFromApi = Array.isArray(auth?.data?.roles)
        ? auth.data.roles
        : [];
      let permissionsFromApi = [];

      const { data: userInfo } = await fetchUserInfo({
        variables: { id: userId },
        context: {
          headers: {
            authorization: `Bearer ${token}`,
          },
        },
      });

      if (userInfo?.user?.roles?.length) {
        rolesFromApi = userInfo.user.roles;
      }
      permissionsFromApi = Array.isArray(userInfo?.user?.permissions)
        ? userInfo.user.permissions
        : [];

      if (!permissionsFromApi.length) {
        const { data: rolesData } = await fetchRolesWithPermissions({
          context: {
            headers: {
              authorization: `Bearer ${token}`,
            },
          },
        });
        const roleNameSet = new Set(
          (rolesFromApi || []).map((role) => role?.name).filter(Boolean),
        );
        const rolePermissions = [];
        (rolesData?.roles || []).forEach((role) => {
          if (!roleNameSet.has(role?.name)) return;
          (role?.permissions || []).forEach((permission) => {
            rolePermissions.push(permission);
          });
        });
        if (rolePermissions.length) {
          permissionsFromApi = rolePermissions;
        }
      }

      const nextSignature = buildSignature(rolesFromApi, permissionsFromApi);
      if (nextSignature && nextSignature === lastSignatureRef.current) return;

      lastSignatureRef.current = nextSignature;
      setAuthData({
        ...auth?.data,
        roles: rolesFromApi,
        permissions: permissionsFromApi,
      });
    } catch (error) {
      console.error('Failed to refresh dashboard permissions:', error);
    } finally {
      refreshInFlightRef.current = false;
    }
  }, [
    auth?.data,
    fetchRolesWithPermissions,
    fetchUserInfo,
    getCurrentUserId,
    setAuthData,
  ]);

  useEffect(() => {
    refreshAuthPermissions();
    const intervalId = setInterval(() => {
      refreshAuthPermissions();
    }, 5000);

    const handleFocus = () => {
      refreshAuthPermissions();
    };
    window.addEventListener('focus', handleFocus);

    return () => {
      clearInterval(intervalId);
      window.removeEventListener('focus', handleFocus);
    };
  }, [refreshAuthPermissions]);

  if (!auth || !auth.data || auth.loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: '60vh' }}
      >
        <Loader />
      </div>
    );
  }

  return (
    <>
      <div className="mb-3 pb-1 top-head">
        <div className="d-flex align-items-center">
          <Heading title="Dashboard" />
        </div>
      </div>
      <DashboardCardChart permissions={permissions} />
      <ActiveUserMetrics />

      <AllTabsAndTables permissions={permissions} />

      <Row className="mt-4">
        <Col md={12} className="mb-4">
          {permissions.history ? (
            <FirebaseGradeTouchData />
          ) : (
            <CardWithTitle title="History" className="card-box">
              <PermissionNotice message="You do not have permission to view History." />
            </CardWithTitle>
          )}
        </Col>
      </Row>

      {/* Notification and Task Management Section */}
      <NotificationTaskSection permissions={permissions} />

      <Row className="mt-4">
        <Col md={12} className="mb-4">
          {permissions.orderStatus ? (
            <OrderStatusChart />
          ) : (
            <CardWithTitle title="Order Status" className="card-box">
              <PermissionNotice message="You do not have permission to view Order Status." />
            </CardWithTitle>
          )}
        </Col>
      </Row>
    </>
  );
};

export default Dashboard;
